import { Component, Input } from '@angular/core';
import { NgForm, ControlContainer } from '@angular/forms'

import { PatientRatio } from 'src/shared/models/patient-ratio.model';
import { InpatientConfiguration } from 'src/shared/models/inpatient-configuration.model';
import { CostCenterConfigurationService } from 'src/shared/services/cost-center-configuration.service';
import { Constants } from 'src/shared/utilities/constants.util';
import { ShiftScheduleService } from 'src/shared/services/shift-schedule.service';
import { ShiftSchedule } from 'src/shared/models/shift-schedule.model';

@Component({
    selector: 'smt-inpatient',
    templateUrl: './inpatient.component.html',
    styleUrls: ['./inpatient.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class InpatientComponent {
    @Input() configuration: InpatientConfiguration;
    @Input() readOnly: boolean;
    schedules: ShiftSchedule[];
    isRadioButtonReadOnly: string;
    isFutureShiftBlockAvailable: boolean;

    constructor(
        private _shiftScheduleService: ShiftScheduleService,
        private _costCenterConfigurationService: CostCenterConfigurationService) { }

    ngOnInit() {
        if (!this.configuration.patientRatios) {
            this.configuration.patientRatios = [];
        }
        this.loadSchedules();
        this.validate();
        this.isRadioButtonReadOnly = this.readOnly ? 'disabled' : null;
        this._costCenterConfigurationService.isFutureShiftRecordPresent$.subscribe(futureShiftRecordFlag => {
            this.isFutureShiftBlockAvailable = futureShiftRecordFlag;
            if (futureShiftRecordFlag) {
                this._costCenterConfigurationService.announceWarning(this._costCenterConfigurationService.staffingGridLockOutMessage);
            }
            else {
                this._costCenterConfigurationService.clearWarning();
            }
        });
    }

    async loadSchedules() {
        if (this.configuration.costCenterId) {
            this._costCenterConfigurationService.announceAdminActionLoading(true);
            this.schedules = await this._shiftScheduleService.getActiveShiftSchedulesByCostCenter(this.configuration.costCenterId);
            this._costCenterConfigurationService.announceAdminActionLoading(false);
        }
    }

    onAddPatientRatio() {
        this.reInitializePatientRatioConfiguration();
        let ratio = new PatientRatio();
        ratio.costCenterId = this.configuration.id;
        ratio.label = "";
        this.configuration.patientRatios.push(ratio);
        this.validate();
    }

    onRemovePatientRatio(index: number) {
        this.configuration.patientRatios.splice(index, 1);
        this.announceFormIsDirty();
    }
    onChangeTotalPatientCensus() {
        let totalCount = this.configuration.patientRatios.length;
        this.configuration.patientRatios.splice(0, totalCount);
        this.validate();
    }


    get isNewCostCenter(): boolean {
        return !this.configuration.id;
    }

    onChangeMinMaxCensus() {
        if (!this.isNewCostCenter && this._shiftScheduleService.areSchedulesPresent(this.schedules))
            this._costCenterConfigurationService.announceWarning(Constants.ResetStaffingGridWarning);
        this.validate();
    }

    validate() {
        this._costCenterConfigurationService.announceFormIsValid(this.isValid);
    }

    get invalidMinMax(): boolean {
        return !this.configuration
            || this.configuration.minCensus >= this.configuration.maxCensus;
    }

    get invalidMinCensus(): boolean {
        return this.configuration.minCensus < 0;
    }

    get invalidMaxCensus(): boolean {
        return this.configuration.maxCensus < 0;
    }


    get missingTransfersCheckbox(): boolean {
        return !this.configuration
            || (!this.configuration.transfers && this.configuration.transfers !== false);
    }

    get missingRatios(): boolean {
        return this.configuration
            && this.configuration.totalPatientCensus === false
            && (!this.configuration.patientRatios || this.configuration.patientRatios.length === 0)
    }

    get missingRatiosCheckbox(): boolean {
        return this.configuration
            && (!this.configuration.totalPatientCensus && this.configuration.totalPatientCensus !== false);
    }

    get isValid(): boolean {
        return !this.invalidMinMax
            && !this.invalidMinCensus
            && !this.invalidMaxCensus
            && !this.missingTransfersCheckbox
            && !this.missingRatiosCheckbox
            && !this.missingRatios;
    }
    get shouldDisplayPatientRatios(): boolean {
        return this.missingRatiosCheckbox
            || this.configuration.totalPatientCensus === true;
    }
    get isValidStaffAndPatientValue(): boolean {
        return this.configuration.patientRatios.filter((ratio, index) => ratio.patients <= 0 || ratio.staffs <= 0).length > 0;
    }
    announceFormIsDirty() {
        this._costCenterConfigurationService.announceFormIsDirty();
    }
    private reInitializePatientRatioConfiguration() {
        this.configuration.patientRatios = this.configuration.patientRatios.map((value) => {
            let patientRatio = new PatientRatio();
                patientRatio.costCenterId = value.costCenterId,
                patientRatio.id = value.id,
                patientRatio.label = value.label;
                patientRatio.patients = value.patients;
                patientRatio.staffs = value.staffs;
            return patientRatio;
        });
    }
}
